import { Button } from '@cimpress/react-components';
import { Moment } from 'moment-timezone';
import { equals } from 'ramda';
import React, { useEffect, useState } from 'react';
import DateFilter from '../../components/ShipmentsTable/filters/DateFilter';
import ReferencesFilter from '../../components/ShipmentsTable/filters/ReferencesFilter';
import StatusFilter from '../../components/ShipmentsTable/filters/StatusFilter';
import { LocaleSettings } from '../../models/location';
import { GetShipmentsQuery, ShipmentStatus } from '../../ports/ShipmentsService';
import { FlexBox, FlexDirection, FlexGrow, JustifyContent } from '../../utils/css-classes';

// tslint:disable-next-line:import-name
import style from './index.module.css';

// tslint:disable-next-line:function-name
export function ShipmentsExplorerFilters(
  {
    localeSettings,
    onFiltersChange,
  }: {
    localeSettings: LocaleSettings;
    onFiltersChange: (query: GetShipmentsQuery) => void;
  },
) {
  const [showFilters, setShowFilters] = useState(false);

  const [tags, setTags] = useState<string[]>([]);
  const [references, setReferences] = useState<string[]>([]);
  const [status, setStatus] = useState<ShipmentStatus[]>([]);
  const [createdBefore, setCreatedBefore] = useState<Moment>();
  const [createdAfter, setCreatedAfter] = useState<Moment>();
  const [sortedBefore, setSortedBefore] = useState<Moment>();
  const [sortedAfter, setSortedAfter] = useState<Moment>();
  const [manifestedBefore, setManifestedBefore] = useState<Moment>();
  const [manifestedAfter, setManifestedAfter] = useState<Moment>();
  const [carrierAccountKeys, setCarrierAccountKeys] = useState([]);

  const [query, setQuery] = useState<GetShipmentsQuery>({});

  const clearFilters = () => {
    setReferences([]);
    setStatus([]);
    setCarrierAccountKeys([]);
    setTags([]);
    setCreatedBefore(undefined);
    setCreatedAfter(undefined);
    setSortedBefore(undefined);
    setSortedAfter(undefined);
    setManifestedBefore(undefined);
    setManifestedAfter(undefined);
  };

  useEffect(
    () => {
      if (
        !equals(references, query.references) ||
        !equals(status, query.status) ||
        !equals(carrierAccountKeys, query.carrierAccountKeys) ||
        !equals(tags, query.tags) ||
        !equals(createdBefore?.utc().format(), query.createdBefore) ||
        !equals(createdAfter?.utc().format(), query.createdAfter) ||
        !equals(sortedBefore?.utc().format(), query.sortedBefore) ||
        !equals(sortedAfter?.utc().format(), query.sortedAfter) ||
        !equals(manifestedBefore?.utc().format(), query.manifestedBefore) ||
        !equals(manifestedAfter?.utc().format(), query.manifestedAfter)
      ) {
        const q = {
          references,
          status,
          carrierAccountKeys,
          tags,
          createdBefore: createdBefore?.utc().format(),
          createdAfter: createdAfter?.utc().format(),
          sortedBefore: sortedBefore?.utc().format(),
          sortedAfter: sortedAfter?.utc().format(),
          manifestedBefore: manifestedBefore?.utc().format(),
          manifestedAfter: manifestedAfter?.utc().format(),
        };
        setQuery(q);
        onFiltersChange(q);
      }
    },
    [
      status,
      carrierAccountKeys,
      createdBefore,
      createdAfter,
      sortedBefore,
      sortedAfter,
      manifestedAfter,
      manifestedBefore,
      references,
    ],
  );

  return <div>
    <div className={`${FlexBox.FLEX} ${FlexDirection.ROW} ${JustifyContent.SPACE_BETWEEN}`}>
      <Button type="primary" onClick={() => setShowFilters(!showFilters)}>
        Filters
      </Button>
      <Button type="secondary" onClick={clearFilters}>Clear all filters</Button>
    </div>
    <div className={`${style.Filters} ${showFilters ? style.Active : ''}`}>
      <ReferencesFilter onChange={setReferences} />
      <div className={`${FlexBox.FLEX} ${FlexDirection.ROW} ${JustifyContent.SPACE_BETWEEN}`}>
        <div className={`${FlexBox.FLEX} ${FlexDirection.ROW}`}>
          <DateFilter
            title="Created after"
            localeSettings={localeSettings}
            className={FlexGrow.GROW_1}
            onChange={setCreatedAfter}
            isValidDate={(current: Moment) => createdBefore ? current.isBefore(createdBefore) : true}
          />&nbsp;
          <DateFilter
            title="Created before"
            localeSettings={localeSettings}
            className={FlexGrow.GROW_1}
            onChange={setCreatedBefore}
            isValidDate={(current: Moment) => createdAfter ? current.isAfter(createdAfter) : true}
          />
        </div>
        <div className={`${FlexBox.FLEX} ${FlexDirection.ROW}`}>
          <DateFilter
            title="Sorted after"
            localeSettings={localeSettings}
            className={FlexGrow.GROW_1}
            onChange={setSortedAfter}
            isValidDate={(current: Moment) => sortedBefore ? current.isBefore(sortedBefore) : true}
          />&nbsp;
          <DateFilter
            title="Sorted before"
            localeSettings={localeSettings}
            className={FlexGrow.GROW_1}
            onChange={setSortedBefore}
            isValidDate={(current: Moment) => sortedAfter ? current.isAfter(sortedAfter) : true}
          />
        </div>
        <div className={`${FlexBox.FLEX} ${FlexDirection.ROW}`}>
          <DateFilter
            title="Manifested after"
            localeSettings={localeSettings}
            className={FlexGrow.GROW_1}
            onChange={setManifestedAfter}
            isValidDate={(current: Moment) => manifestedBefore ? current.isBefore(manifestedBefore) : true}
          />&nbsp;
          <DateFilter
            title="Manifested before"
            localeSettings={localeSettings}
            className={FlexGrow.GROW_1}
            onChange={setManifestedBefore}
            isValidDate={(current: Moment) => manifestedAfter ? current.isAfter(manifestedAfter) : true}
          />
        </div>
      </div>
      <StatusFilter onChange={setStatus} />
    </div>
  </div>;
}
